import {useCallback, useMemo} from 'react';
import {Table} from '@tanstack/react-table';
import {useDeleteMany} from '@refinedev/core';
import {defaultMutationOptions} from '@/pages/_utils';
import {TrashIcon} from 'lucide-react';

export const useBulkDelete = (resource: string, table: Table<any>) => {
  const deleteMany = useDeleteMany({
    mutationOptions: defaultMutationOptions,
  });

  const selectedRows = useMemo(
    () => table.getFilteredSelectedRowModel().rows,
    [table.getFilteredSelectedRowModel().rows],
  );

  const onConfirm = useCallback(() => {
    const ids = selectedRows.map(row => row.original.id);
    console.log('ids', ids);
    deleteMany.mutate({
      resource,
      ids,
    });
  }, [deleteMany, resource, selectedRows]);

  return useMemo(() => {
    const count = selectedRows.length;
    // console.log('count', count);
    return {
      icon: <TrashIcon />,
      title: `Xóa ${count} bản ghi`,
      confirmTitle: `Xác nhận xóa ${count} bản ghi?`,
      confirmContent: `Bạn có chắc chắn muốn xóa?`,
      onConfirm,
    };
  }, [onConfirm, selectedRows]);
};
